var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCh(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 63,
    viewBox: "0 0 78 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.92 54.28L28.54 56.52C25.08 60.49 20.6 62.6 16 62.6C7.3 62.6 0 55.31 0 46.54C0 37.77 7.3 30.54 16 30.54C20.61 30.54 25.09 32.59 28.54 36.62L25.92 38.8C23.1 35.54 19.71 33.94 16 33.94C8.96 33.94 3.39 39.51 3.39 46.55C3.39 53.59 8.96 59.22 16 59.22C19.71 59.22 23.1 57.62 25.92 54.29V54.28Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6291 47.11V62.6H74.1691V47.11C74.1691 39.75 68.4091 33.99 61.0491 33.99C53.6891 33.99 47.9291 39.75 47.9291 47.11V62.6H44.5391V0H47.9291V36.8C49.5891 33.98 54.9691 30.59 61.0491 30.59C70.0691 30.59 77.6291 38.08 77.6291 47.1V47.11Z",
    fill: "transparent"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCh);
export default __webpack_public_path__ + "static/media/CH.d71fd05757d3d2326cd2559b2f3af0a3.svg";
export { ForwardRef as ReactComponent };